import { Component, Inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EsTemplateService } from 'src/app/core/api-services/shared/es-template.service';
import { EsResponseModel } from 'src/app/core/api-services/shared/EsResponseModel';
import { EsRequestCardExtraBaseComponent } from 'src/app/services/es-shared/base/EsRequestCardExtraBaseComponent';
import { CitesImportSpeciesMapper } from '../CitesImportSpeciesMapper';
import { CitesImportSpeciesWorkflowService } from '../cites-import-species-workflow.service';
import { CitesImportSpeciesTransaction } from 'src/app/core/models/cites/cites-import-species/CitesImportSpeciesTransaction';
import { CitesImportSpeciesServiceRequestDto } from 'src/app/core/models/cites/cites-import-species/CitesImportSpeciesServiceRequestDto';

@Component({
  selector: 'app-cites-import-species-request-card-extra',
  templateUrl: './cites-import-species-request-card-extra.component.html',
})
export class CitesImportSpeciesRequestCardExtraComponent
  extends EsRequestCardExtraBaseComponent
  implements OnInit
{
  isCollapsed: boolean = false;

  serviceDetails?: CitesImportSpeciesTransaction;

  constructor(
    translateService: TranslateService,
    @Inject('apiService')
    public apiService: EsTemplateService<any>,
    @Inject('mapperService')
    public mapperService: CitesImportSpeciesMapper,
    @Inject('WorkflowService')
    public workflowService: CitesImportSpeciesWorkflowService
  ) {
    super(translateService);
  }

  ngOnInit(): void {}

  public async loadRequestDetails(): Promise<void> {
    const response = await this.apiService
      .getRequest<EsResponseModel<CitesImportSpeciesServiceRequestDto>>(
        this.requestId.toString()
      )
      .toPromise();

    this.serviceDetails = this.mapperService.mapUltimate(response.Data);
  }

  public downloadVerificationDocument($event: any) {
    this.workflowService.globalObject.ServiceDetailsConfiguration.id = this.requestId;
    this.workflowService.DownloadVerificationDocument($event);
  }
}
